import { render, staticRenderFns } from "./MessageCard.vue?vue&type=template&id=ad5607f4&scoped=true"
import script from "./MessageCard.vue?vue&type=script&lang=ts"
export * from "./MessageCard.vue?vue&type=script&lang=ts"
import style0 from "./MessageCard.vue?vue&type=style&index=0&id=ad5607f4&prod&lang=css"
import style1 from "./MessageCard.vue?vue&type=style&index=1&id=ad5607f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_babel-core@6.26.3_css-loader@6.11.0_webpack@5.98._lpz7yfflcfbikbc3glhfyeagle/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad5607f4",
  null
  
)

export default component.exports